import { SocialLogin } from '@capgo/capacitor-social-login';
import { Capacitor } from '@capacitor/core';

export const initializeGoogleAuth = async () => {
  // Initialize Google Auth for Capacitor using Capgo Social Login
  await SocialLogin.initialize({
    google: {
      webClientId: '36562032704-ulh70vi69emb1qqntmk2jjhuobnch1hb.apps.googleusercontent.com',
      iOSClientId: '36562032704-bvd5u3bl73gg98hohlkbfepo765novuk.apps.googleusercontent.com',
      iOSServerClientId: '36562032704-ulh70vi69emb1qqntmk2jjhuobnch1hb.apps.googleusercontent.com'
    }
  });
}; 